/** パスキー（WebAuthn）での端末登録とログイン（ADR-0004）。 */
import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
} from "@simplewebauthn/browser";
import { api, store } from "./api.js";

export const passkeysSupported = () => browserSupportsWebAuthn();

export async function enroll(enrollCode: string, deviceName: string): Promise<void> {
  const { options, challenge_token, device_id } = await api<{
    options: Parameters<typeof startRegistration>[0]["optionsJSON"];
    challenge_token: string;
    device_id: string;
  }>("/v1/auth/register/options", { enroll_code: enrollCode, device_name: deviceName });
  const response = await startRegistration({ optionsJSON: options });
  const r = await api<{ session_token: string; device_id: string }>("/v1/auth/register/verify", {
    challenge_token,
    response,
  });
  store.token = r.session_token;
  store.deviceId = r.device_id ?? device_id;
}

export async function login(): Promise<void> {
  const { options, challenge_token } = await api<{
    options: Parameters<typeof startAuthentication>[0]["optionsJSON"];
    challenge_token: string;
  }>("/v1/auth/login/options", {});
  const response = await startAuthentication({ optionsJSON: options });
  const r = await api<{ session_token: string; device_id: string }>("/v1/auth/login/verify", {
    challenge_token,
    response,
  });
  store.token = r.session_token;
  store.deviceId = r.device_id;
}

export async function logout(): Promise<void> {
  try {
    await api("/v1/auth/logout", {});
  } catch {
    /* 失効済みでも端末側は消す */
  }
  store.token = null;
}

export async function me(): Promise<{
  principal_id: string;
  device_id: string;
  display_name: string;
  /** 入力欄の調整値（config/client.yaml。ADR-0040）。古い Gateway は返さない（PWA の既定値で動く） */
  input?: unknown;
} | null> {
  if (!store.token) return null;
  try {
    return await api("/v1/me");
  } catch {
    store.token = null;
    return null;
  }
}
